import ReactDOM from 'react-dom';

export const openlightbox = (as) => {
    const lightbox = document.getElementById('lightbox');
    ReactDOM.render(as, lightbox);

    lightbox.classList.remove('lightboxHide');
    lightbox.classList.add('lightbox');
}

export const closelightbox = () => {
    const lightbox = document.getElementById('lightbox');
    lightbox.classList.add('lightboxHide');
    lightbox.classList.remove('lightbox');

    ReactDOM.unmountComponentAtNode(lightbox);
}

export const printError = (field) => {
    let label = field.message;
    switch (field.type) {
        case 'required':
            label = 'Dato obligatorio';
            break;
        case 'minLength':
            if (field.message) {

            } else if (field.ref.minLength) {
                label = `Longitud mínima es ${field.ref.minLength}`;
            } else {
                label = `Longitud mínima no ha sido alcanzada`;
            }
            break;
        case 'maxLength':
            if (field.message) {

            } else if (field.ref.maxLength) {
                label = `Longitud máxima es ${field.ref.maxLength}`;
            } else {
                label = `Longitud máxima ha sido superada`;
            }
            break;
        default:
            label = field.message;
    }
    return label;
}

export const formatMoney = (number, useSign = true, decPlaces = 2, decSep = '.', thouSep = ',') => {
    var i: any = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
    var j = i.length > 3 ? i.length % 3 : 0;
    
    return (useSign ? ' $' : '$') + 
        (j ? i.substring(0, j) + thouSep : '') +
        i.substring(j).replace(/(decSep{3})(?=decSep)/g, '$1' + thouSep) +
        (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : '');
}